import eventBus from "./eventBus.js";
import moment from "moment";
import datepicker from 'vuejs-datepicker';
import { zh } from 'vuejs-datepicker/dist/locale'
import menuDefList from './json/menu.json';
const store = window.sessionStorage;
function expand( $li ) {
	$li.children( 'ul.nav-children' ).slideDown( 'fast', function() {
		$li.addClass( 'nav-expanded' );
		$(this).css( 'display', '' );
		ensureVisible( $li );
	});
}

function collapse( $li ) {
	$li.children('ul.nav-children' ).slideUp( 'fast', function() {
		$(this).css( 'display', '' );
		$li.removeClass( 'nav-expanded' );
	});
}

function ensureVisible( $li ) {
	var scroller = $li.offsetParent();
	if ( !scroller.get(0) ) {
		return false;
	}

	var top = $li.position().top;
	if ( top < 0 ) {
		scroller.animate({
			scrollTop: scroller.scrollTop() + top
		}, 'fast');
	}
}

function buildSidebarNav( anchor, prev, next, ev ) {
	if ( anchor.prop('href') ) {
		var arrowWidth = parseInt(window.getComputedStyle(anchor.get(0), ':after').width, 10) || 0;
		if (ev.offsetX > anchor.get(0).offsetWidth - arrowWidth) {
			ev.preventDefault();
		}
	}

	if ( prev.get( 0 ) !== next.get( 0 ) ) {
		collapse( prev );
		expand( next );
	} else {
		collapse( prev );
	}
}
export default{
	mounted() {

        // Panels
        $('.panel', this.$el)
            .on('panel:toggle', function () {
                var $this,
                    direction;

                $this = $(this);
                direction = $this.hasClass('panel-collapsed') ? 'Down' : 'Up';

                $this.find('.panel-body, .panel-footer')['slide' + direction](200, function () {
                    $this[(direction === 'Up' ? 'add' : 'remove') + 'Class']('panel-collapsed')
                });
            })
            .on('panel:dismiss', function () {
                var $this = $(this);

                if (!!($this.parent('div').attr('class') || '').match(/col-(xs|sm|md|lg)/g) && $this.siblings().length === 0) {
                    var row = $this.closest('.row');
                    $this.parent('div').remove();
                    if (row.children().length === 0) {
                      row.remove();
                    }
                } else {
                    $this.remove();
                }
            })
            .on('click', '[data-panel-toggle]', function (e) {
                e.preventDefault();
                $(this).closest('.panel').trigger('panel:toggle');
            })
            .on('click', '[data-panel-dismiss]', function (e) {
                e.preventDefault();
                $(this).closest('.panel').trigger('panel:dismiss');
            })
            /* Deprecated */
            .on('click', '.panel-actions a.fa-caret-up', function (e) {
                e.preventDefault();
                var $this = $(this);

                $this
                    .removeClass('fa-caret-up')
                    .addClass('fa-caret-down');

                $this.closest('.panel').trigger('panel:toggle');
            })
            .on('click', '.panel-actions a.fa-caret-down', function (e) {
                e.preventDefault();
                var $this = $(this);

                $this
                    .removeClass('fa-caret-down')
                    .addClass('fa-caret-up');

                $this.closest('.panel').trigger('panel:toggle');
            })
            .on('click', '.panel-actions a.fa-times', function (e) {
                e.preventDefault();
                var $this = $(this);

                $this.closest('.panel').trigger('panel:dismiss');
			});

		$('.nav-children > li > a.nav-content').click(()=>{
			$("body").removeAttr("style")
			$("html").removeClass("sidebar-left-opened");
		});
	},
	data(){
		return {
			zh:zh,
			bus: eventBus,
		};
	},
	methods:{
		isAdmin(module){
			let result = false;
			if(this.isLogin){
				result = this.sessionData.accountType == "ADM";
				if(this.sessionData.funcAdmin !== null){
					const funcAdmin = JSON.stringify(this.sessionData.funcAdmin);
					if(funcAdmin){
						result = funcAdmin.includes(module);
					}
				}
			}
			return result;
		},
		setStore(key, content){
			if(["object"].includes((typeof content))){
				store.setItem(key, JSON.stringify(content));
			}else{
				store.setItem(key, content);
			}
		},
		getStore(key){
			return store.getItem(key);
		},
		clearStore(){
			store.clear();
		},
		removeStore(key){
			store.removeItem(key);
		},
		customFormatter(date, formatString) {
			if(!formatString){
				formatString = "YYYY/MM/DD";
			}
			return moment.tz(date, "Asia/Taipei").format(formatString);
		},
		dateFormatter(date) {
			return moment.tz(date, "Asia/Taipei").toDate();
		},
		jsonIsEmpty(jsonObj){
			return (Object.keys(jsonObj).length === 0 && jsonObj.constructor === Object)
		},
		imgPreview(file) {
			return new Promise(function (resolve, reject) {
				let reader = new FileReader()
				reader.readAsDataURL(file)
				reader.onload = function () {
					resolve(this.result)
				}
			});
		},
		checkFileExtension(fileName, available){
			let result = false;
			let extension =  fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 2);
			extension = extension.toLowerCase();
			// console.log(extension);
			if(available){
				if(Array.isArray(available)){
					result = available.includes(extension)
				}else if(typeof available == "string"){
					result = available.trim().split(",").includes(extension);
				}
			}else{
				result = ["jpeg", "jpg", "png", "pdf"].includes(extension);
			}
			return result;
		},
		nowDate(){
			var now = new Date();
			// now.setFullYear(now.getFullYear() + 1);
			return moment.tz(now, "Asia/Taipei").toDate();
		},
		gotoView(pathName, params) {
			if(params){
				this.setStore(pathName, params);
			}
			this.$router.push({ name: pathName, params:params});
		},
		downloadFile(fileName, apiUrl = ""){
			const api = apiUrl == "" ? "/api/Common/downloadFile/"+fileName : apiUrl;
			this.$axios.post(api, JSON.stringify({}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", fileName);
				document.body.appendChild(link);
				link.click();
			});
		},
		getNumbers(start, stop) {
            return new Array(stop - start + 1).fill(start).map((n, i) => n + i);
        },
        getNumbersDesc(start, stop) {
            return new Array(start - stop + 1).fill(start).map((n, i) => n - i);
		},
		download2File(res) {
            let filename = "";
            let disposition = res.headers.map["content-disposition"][0];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                let filenameArray = disposition.split(';');
                filename = decodeURIComponent(filenameArray[2].replace("filename*=UTF-8''", "").trim());
            }
            let headers = res.headers.map;
            let blob = new Blob([res.data], {
                type: headers["content-type"]
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
		},
		buildMenu(){
			// console.log(this.sessionData.accountType);
			let menuObj = {};
			let useMObj = {
				root:["bulletin", "offSiteLink"],
				bulletin:["news", "stayInDuct"],
        newStuApply:[],
        partTimeMage:[],
				offSiteLink:["link1"]
			};
			if(this.isLogin){
				if(this.sessionData.accountType == "ADM"){
					useMObj = {
						//主目錄
            root:["bulletin","military", "stay", "stipendMage", "assist", "tenancy", "technoDatabase", "offSiteLink", "authSetting"],
						//最新消息
						bulletin:["news", "stayInDuct"],
            newStuApply:[],
						//宿舍
						stay:["news","training","list", "assignRoom", "intoRoom", "leave", "mage", "stayLife"],
						stayLife:["overnight", "rollcall", "deduct", "borrow", "environmentSettingClean", "environmentSettingCleanStaff", "environmentAudit", "menjin"],
						//
						//助學金
						stipendMage:["budget", "partTimeMage", "lifeWorkstudyMage", "verification"],
						budget:["import", "index"],
						partTimeMage:["workstudy", "leaveAudit", "keepManage"],
            lifeWorkstudyMage: ["lifeWorkstudyList", "lifeWorkstudyTimeSetting"],
						verification:["audit","backup", "export"],
            //助學措施
            assist:["relief", "weak"],
            relief:["list", "fee", "export", "report", "setting"],
            weak:["list", "export", "report", "setting"],
            //賃居
						tenancy:["news","rent-subsidy", "safety","register", "visit", "instructor", "mail", "opinionback", "statistic"],
						//兵役
						military:["base","apply","setting"],
						technoDatabase:["report"],
						offSiteLink:["link1"],
						authSetting:["authority"]
					};
				}else if(this.sessionData.accountType == "TCH"){
					if(this.getStore("menu")){
						useMObj = JSON.parse(this.getStore("menu"));
					}
				}else if(this.sessionData.accountType == "STU"){
					useMObj.root.push("stay");
					useMObj["stay"] = ["news","training","list","assignRoom","stayLife"];
					useMObj["stayLife"] = ["overnight","deduct","borrow", "environmentAudit"];

					//賃居
					useMObj.root.push("tenancy");
					useMObj["tenancy"] = ["news","rent-subsidy","register","opinionback"];

          //助學措施
          useMObj.root.push("assist");
          useMObj["assist"] = ["relief","weak"];
          useMObj["relief"] = ["list"];
          useMObj["weak"] = ["list"];

          //助學金
          useMObj.root.push("stipendMage");
          useMObj["stipendMage"] = ["lifeWorkstudyMage"];
          useMObj["lifeWorkstudyMage"] = ["lifeWorkstudyList"];

          //兵役
					if(this.sessionData.sex == "M"){
						useMObj.root.push("military");
						useMObj["military"] = ["student"];
					}
					// */
					if(this.sessionData.isRoomMage == "Y"){
						useMObj.stay.push("leave");
						useMObj.stayLife.push("rollcall");
						useMObj.stayLife.push("violate");
						//打掃點
						useMObj.stayLife.push("environmentSettingCleanStaff");
					}
					if(this.sessionData.isHire == "Y"){
            useMObj.stipendMage.push("partTimeMage");
            useMObj["partTimeMage"] = ["student"];

          }
				}
			}else{
        useMObj.bulletin.push("newStuApply");
				useMObj.bulletin.push("stayApplySearch");
				useMObj.bulletin.push("stayBillingInvoice");
        useMObj.bulletin.push("reliefApplySearch");
        useMObj.bulletin.push("lifeWorkstudyApplySearch");
        useMObj.newStuApply.push("stayApply");
        useMObj.newStuApply.push("reliefApply");
        useMObj.newStuApply.push("lifeWorkstudyApply");
      }
			const jStr = JSON.stringify(menuDefList);
			let jObj = JSON.parse(jStr);
			for(let key in jObj){
				menuObj[key] = [];
				if(key in useMObj){
					let mArr = useMObj[key];
					jObj[key].nodes.forEach(obj =>{
						if(mArr.includes(obj.id)){
							if(obj.id == "environmentAudit" && this.sessionData.accountType == "STU" && this.sessionData.isRoomMage != "Y"){
								obj.title = "打掃點";
							}
							menuObj[key].push(obj);
						}
					});
				}
			}
			return menuObj;
		},
		htmlEncode(encodeValue){
			const div = document.createElement('div');
			div.appendChild(document.createTextNode(encodeValue));
			return div.innerHTML;
		},
		htmlDecode(decodeValue){
			const div = document.createElement('div');
			div.innerHTML = decodeValue;
			return div.innerText || div.textContent;
		},
		compresImage(file){
			let _this = this;
			return new Promise(resolve =>{
				if(!file || !window.FileReader){
					resolve(file);
				}else{
					let reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onloadend = function(){
						let result = this.result;
						let image = new Image();
						image.src = result;
						if(this.result.length <= 100 * 1024){
							resolve(file);
						}else{//圖片壓縮
							image.onload = function() {
								let dataURI = _this.compress(image);
								let byteString = "";
								if (dataURI.split(',')[0].indexOf('base64') >= 0)
									byteString = atob(dataURI.split(',')[1]);
								else
									byteString = unescape(dataURI.split(',')[1]);

								let ia = new Uint8Array(byteString.length);
								for (let i = 0; i < byteString.length; i++) {
									ia[i] = byteString.charCodeAt(i);
								}
								let resultImg = new File([new Uint8Array(ia)], file.name, {type: file.type});
								// console.log(resultImg);
								resolve(resultImg);
							};
						}
					}
				}
			});
		},
		compress(img){
			let canvas = document.createElement("canvas");
			let ctx = canvas.getContext("2d");
			//瓦片canvas
			let tCanvas = document.createElement("canvas");
			let tctx = tCanvas.getContext("2d");
			let initSize = img.src.length;
			let width = img.width;
			let height = img.height;
			//如果圖片大於四百萬畫素，計算壓縮比並將大小壓至400萬以下
			let ratio;
			if ((ratio = width * height / 4000000) > 1) {
				// console.log("大於400萬畫素");
				ratio = Math.sqrt(ratio);
				width /= ratio;
				height /= ratio;
			} else {
				ratio = 1;
			}
			canvas.width = width;
			canvas.height = height;
			//鋪底色
			ctx.fillStyle = "#fff";
			ctx.fillRect(0, 0, canvas.width, canvas.height);
			//如果圖片畫素大於100萬則使用瓦片繪製
			let count;
			if ((count = width * height / 1000000) > 1) {
				// console.log("超過100W畫素");
				count = ~~(Math.sqrt(count) + 1); //計算要分成多少塊瓦片
				//            計算每塊瓦片的寬和高
				let nw = ~~(width / count);
				let nh = ~~(height / count);
				tCanvas.width = nw;
				tCanvas.height = nh;
				for (let i = 0; i < count; i++) {
					for (let j = 0; j < count; j++) {
						tctx.drawImage(img, (i * nw * ratio), (j * nh * ratio), (nw * ratio), (nh * ratio), 0, 0, nw, nh );
						ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
					}
				}
			} else {
				ctx.drawImage(img, 0, 0, width, height);
			}

			//進行最小壓縮
			let ndata = canvas.toDataURL("image/jpeg", 0.1);
			// console.log("壓縮前：" + initSize);
			// console.log("壓縮後：" + ndata.length);
			// console.log("壓縮率：" + ~~(100 * (initSize - ndata.length) / initSize) + "%" );
			tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
			return ndata;
		},
		async appInit(){
			if(this.getStore("oitToken")){
				const api = "/api/Index/gainUserInfo";
				await this.$axios.post(api).then(resp =>{
					if (resp.data.status == "success"){
						this.setStore("oitToken", resp.data.data.token);
						this.setStore("session.data", resp.data.data.sessionData);
					}else{
						this.clearStore();
					}
				}).catch(error =>{
					if ([401, 403].includes(error.response.status)) {
						this.clearStore();
					}
				});
				this.gainApplySmtr();
			}
		},
		async gainApplySmtr(){
			const api = "/api/Common/commCodeList/ROOM";
			let resp = await this.$axios.post(api);
			let result = resp.data.data;
			let applySetting = result.filter(item => {
				return item.commCode == "APPLY_YM";
			});
			this.setStore("applySmtr", applySetting[0].commValue + applySetting[0].commValue2);
		}
	},
	components: {
		datepicker
	},
	computed:{
		sessionData: function(){
			let sessionData = {};
			if(this.getStore("session.data")){
				sessionData =JSON.parse(this.getStore("session.data"));
			}
			return sessionData;
		},
		isLogin:function(){
			if(this.getStore("session.data")){
				return true;
			}
			return false;
		},
		applySmtr(){
			let result = "";
			if(this.getStore("applySmtr")){
				result = this.getStore("applySmtr");
			}
			return result;
		},
		nowSyear(){
			let nowYear = (new Date().getFullYear() - 1911);
			if((new Date().getMonth() + 1) < 8){
				nowYear = nowYear-1;
			}
			return nowYear;
		},
		nowSmtr(){
			let str = "";
			if(new Date().getUTCMonth() >=0 && new Date().getUTCMonth() < 7 ){
				str = (new Date().getUTCFullYear() - 1912).toString() + (new Date().getUTCMonth() == 0 ? "1":"2");
			}else{
				str = (new Date().getUTCFullYear() - 1911).toString() + "1";
			}
			return str;
		}
	}
}
